// this file is generated by update_shopify_store_data.py at 2026-01-26 20:19:28.772579
var courses = [
    {
        "course_id": "AFCE3927-AA42-EF11-998E-005056A7F31D",
        "course_version": 1,
        "name": "ANA: APRN Pharmacology Today: Understanding Treatment of Bipolar Disorder",
        "course_type": 1,
        "author_information": "",
        "description": "Overview: \r\nThis course explores the pharmacologic options for treating bipolar disorder (including bipolar I and bipolar II). It outlines the pharmacotherapeutic principles of the various modalities, with comparative analysis of efficacy and adverse effects and attention to special patient populations. In reviewing the evidence-based guidance and case studies, you will gain comprehensive insight into tailoring pharmacologic approaches to each patient given the unique challenges presented by bipolar disorder.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    Describe the diagnostic criteria for bipolar and related disorders.\r\n    <br />\r\n    Apply the latest evidence and guideline recommendations on bipolar disorder to the pharmacologic treatment of individuals diagnosed with the disorder.<br />\r\n    Compare and contrast the pharmacologic treatments for bipolar disorder, considering pharmacokinetics, pharmacodynamics, and pharmacotherapeutics.\r\n    <br />\r\n    Formulate treatment and monitoring plans, integrating effective pharmacologic interventions for individuals exhibiting symptoms of bipolar disorder.\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Behavioral Health Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DE16FFD5-752E-11DD-8D4B-000423AF2193",
                "course_category_name": "Psychologist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "ED7E45AB-9782-E211-B22E-0015171C1A75",
                "course_category_name": "Psychiatric Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 6.75,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];